import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { isIcon } from '../../utils/isIcon.js';
import { style } from '../../utils/style.js';
import { Img } from '../Img/Img.js';
import { LinkButton } from './LinkButton.js';
/** @deprecated */
export const renderButtonsSection = (buttons, { className, buttonClassName, isVertical } = {}) => buttons?.length && buttons.some((_) => _?.text || _?.icon?.icon) ? (_jsx("div", { className: style('flex', isVertical
        ? 'flex-col gap-xs justify-items-stretch'
        : 'flex-wrap @xl:flex-nowrap gap-lg sm:gap-m w-full @lg:w-auto', className), role: "group", children: buttons.map(renderButton(buttonClassName)) })) : null;
const renderButton = (buttonClassName = '') => (button, index) => {
    const { text, icon, iconRight, version, ...rest } = button || {};
    const iconVersion = getIconVersion(icon, version);
    const iconRightVersion = getIconVersion(iconRight, version);
    return text || icon?.icon ? (_jsx(LinkButton, { className: style('basis-full @lg:basis-auto', buttonClassName), appendLeft: renderButtonIcon({ ...icon, iconVersion }), appendRight: renderButtonIcon({ ...iconRight, iconVersion: iconRightVersion }), version: version, text: text, ...rest }, index ? String(index) : '')) : null;
};
const DEFAULT_ICON_W = 24;
const getIconVersion = (icon, version = 'secondary') => {
    const iconVersionDefault = version === 'secondary' ? 'color' : 'white';
    return icon?.iconVersion || iconVersionDefault;
};
const renderButtonIcon = (icon) => isIcon(icon) && (_jsx(Img, { image: icon, width: String(icon?.size?.width || DEFAULT_ICON_W), height: String(DEFAULT_ICON_W) }));
//# sourceMappingURL=renderButtonsSection.js.map